import { createFileRoute, notFound } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';

import { z } from 'zod';

const resetPasswordSearchSchema = z.object({
  uid: z.string().min(1),
  token: z.string().min(1),
});

export const Route = createFileRoute('/_public/_auth/auth/reset-password/')({
  validateSearch: zodSearchValidator(resetPasswordSearchSchema),
  onError: () => {
    throw notFound();
  },
});
